export default class floatingButton {
    constructor() {
        this.wrapper = document.querySelector('.product__buttons');
        this.item = document.querySelector('.ask-for-product');
        this.init()
    }

    init() {
        if (this.item) {
            window.addEventListener('load', () => this.trackScroll())
            window.addEventListener('scroll', () => this.trackScroll())
            window.addEventListener('resize', () => this.trackScroll())
        }
    }

    trackScroll() {
        const scrolled = window.scrollY;
        const coords = document.documentElement.clientHeight;
        let wrapperPositionTop = this.wrapper.offsetTop;

        if (scrolled > wrapperPositionTop) {
            this.item.classList.add('visible')
        }
        if (scrolled < wrapperPositionTop) {
            this.item.classList.remove('visible')
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./js/modules/floating-button.js
// module id = 7
// module chunks = 0